import React from "react";

import styles from "./styles.scss";
import loader from "./loader.gif";

function Loader() {
  return <img src={loader} className={styles.loader} alt="Loader" />;
}

export { Loader };
